const React = require('react');
const { Link } = require('frontend-spa');
const Card = require('@andes/card');
const { CardContent } = require('@andes/card');
const MenuUtils = require('../../../../../../utils/menu');
const { sanitizePath } = require('../../../../../common/URLSanitizer');
const { getEventTracker } = require('../../../../../../utils/event-tracker');

const CustomCard = ({ lang, cardLink, trackClickData, setActiveItem, siteId, cardImage, cardTitle, cardText }) => {
  const Tracker = getEventTracker();

  return (
    <Card className="online-payments__card" animated>
      <Link
        to={cardLink}
        onClick={() => {
          Tracker.send(`mpdevelopers/click_${trackClickData}`);
          setActiveItem(MenuUtils.getItemFromURLParent(sanitizePath(cardLink), siteId.toLowerCase(), lang));
        }}
      >
        <CardContent className="card-content">
          {cardImage}
          <h3>{cardTitle}</h3>
          <p>{cardText}.</p>
        </CardContent>
      </Link>
    </Card>
  );
};

module.exports = CustomCard;
